import { Component } from 'react';
import Banner from '../components/common/Banner';

export default class Contact extends Component {
  render() {
    return (
      <>
        {/* Page Title */}
        <Banner title={"Contact Bhoomi Rocks Products"} desc={"Get in Touch"} img={"images/bg/bg_1.jpg"} />

        {/* Contact Section */}
        <section className="section contact-page py-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <h2 className="title-color mb-4">Reach Out to Us</h2>
                <p>
                  Have questions about our premium natural stones and minerals or need assistance with your construction or landscaping project? Contact Bhoomi Rocks Products to explore our offerings or discuss tailored solutions. Our team, led by Managing Partner Deepika B, is here to help you transform your spaces.
                </p>
                <div className="mt-4">
                  <h4>Contact Details</h4>
                  <p><strong>Registered Office:</strong> Sy. No. 177, Thammanayakanahalli Village, Kasaba Hobli, Anekal Taluk, Bengaluru Urban District, Karnataka, India</p>
                </div>
              </div>
              <div className="col-lg-6">
                <h2 className="title-color mb-4">Send Us a Message</h2>
                <div className="contact-form">
                  <div className="form-group mb-4">
                    <input type="text" className="form-control" placeholder="Your Name" />
                  </div>
                  <div className="form-group mb-4">
                    <input type="email" className="form-control" placeholder="Your Email" />
                  </div>
                  <div className="form-group mb-4">
                    <input type="tel" className="form-control" placeholder="Your Phone" />
                  </div>
                  <div className="form-group mb-4">
                    <textarea className="form-control" rows="5" placeholder="Your Message"></textarea>
                  </div>
                  <button className="btn btn-main btn-round-full">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </>
    );
  }
}